export default __webpack_public_path__ + "static/ville-de-montreal-7f61915f15a24b613c604d0351023715.png";